<template>
<div class="card">
    <header class="header-card">
      <p>
        {{ $t('detailSociete.produitAssocieLocDefaut.title')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <p class="column is-12 has-text-link">
          {{$t('detailSociete.produitAssocieLocDefaut.info')}}
        </p>
        <div class="column is-6">
          <b-field :label="$t('detailSociete.produitAssocieLocDefaut.unitaire')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{societe.produitsAssociesLoc.face}}
            </span>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field :label="$t('detailSociete.produitAssocieLocDefaut.ecranNumerique')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{societe.produitsAssociesLoc.ecranNum}}
            </span>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field :label="$t('detailSociete.produitAssocieLocDefaut.regroupement')"
                    custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{societe.produitsAssociesLoc.reseauTempo}}
            </span>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field :label="$t('detailSociete.produitAssocieLocDefaut.regroupementNumerique')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{societe.produitsAssociesLoc.reseauNum}}
            </span>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field :label="$t('detailSociete.produitAssocieLocDefaut.regroupementLc')"
                   custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{societe.produitsAssociesLoc.reseauLc}}
            </span>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    societe: Object,
  },
};
</script>

<style>

</style>
